import { AppDispatch } from '@/domain/store';

import { getImpactCalculateVenueCo2ForProject } from '../get-impact-calculate-venue-co2-for-project.action';

const DELAY_FOR_SECOND_CALL = 2000;

export function dispatchTwiceGetImpactVenueCo2(
  dispatch: AppDispatch,
  projectId: number,
) {
  dispatch(getImpactCalculateVenueCo2ForProject({ projectId }));
  setTimeout(
    () => dispatch(getImpactCalculateVenueCo2ForProject({ projectId })),
    DELAY_FOR_SECOND_CALL,
  );
}
